import { useMemo } from 'react';

import {
  CREATE_TIME_FILTER,
  UPDATE_TIME_FILTER,
} from '@spotify/confidence-core-react';
import { useAccountMode } from '@spotify/confidence-graphql';
import {
  CREATOR_FILTER,
  OWNER_FILTER,
} from '@spotify/plugin-confidence-iam-react';
import { experimentsRouteRef } from '@spotify/plugin-confidence-workflows-react';
import {
  ExperimentsPageLayout,
  type ExperimentsPageLayoutProps,
  STATE_FILTER,
  TYPE_FILTER,
  WorkflowInstanceTable,
  createTypeFilter,
} from '@spotify/plugin-confidence-workflows-react';

const REANALYSIS_WORKFLOW_ID = 'reanalysis';
const ANALYSIS_WORKFLOW_ID = 'analysis';

const TYPE_FILTER_WITHOUT_ANALYSIS = createTypeFilter({
  excludeWorkflowIds: [REANALYSIS_WORKFLOW_ID, ANALYSIS_WORKFLOW_ID],
});

const FILTERS = [
  TYPE_FILTER,
  OWNER_FILTER,
  CREATOR_FILTER,
  CREATE_TIME_FILTER,
  UPDATE_TIME_FILTER,
  STATE_FILTER,
];

const FILTERS_TOTAL_CONFIDENCE = [
  TYPE_FILTER_WITHOUT_ANALYSIS,
  OWNER_FILTER,
  CREATOR_FILTER,
  CREATE_TIME_FILTER,
  UPDATE_TIME_FILTER,
  STATE_FILTER,
];

const ExperimentsPageComponent = () => {
  const { isTotalConfidence } = useAccountMode();

  const filters = isTotalConfidence ? FILTERS_TOTAL_CONFIDENCE : FILTERS;
  const tableFilter = isTotalConfidence
    ? `-(parent:"workflows/${REANALYSIS_WORKFLOW_ID}")`
    : undefined;

  const filterExtensions: ExperimentsPageLayoutProps['filterExtensions'] =
    useMemo(
      () =>
        isTotalConfidence
          ? exts =>
              exts.filter(ext => ext.workflowId !== REANALYSIS_WORKFLOW_ID)
          : undefined,
      [isTotalConfidence],
    );

  return (
    <ExperimentsPageLayout
      routeRef={experimentsRouteRef}
      storageKey="confidence-experiments"
      filters={filters}
      filterExtensions={filterExtensions}
      renderTable={({ mode }) => (
        <WorkflowInstanceTable
          mode={mode}
          filter={tableFilter}
          emptyStateProps={{
            type: 'experiment',
            typePlural: 'experiments',
            description: (
              <>
                Experiments include A/B tests and rollouts across your
                workspace.
              </>
            ),
          }}
        />
      )}
    />
  );
};

export const ExperimentsPage = ExperimentsPageComponent;
